import React from "../_snowpack/pkg/react.js";
import ErpaEditor from "./erpa-editor.js";
import SimpleEditor from "./simple-editor.js";
import {getPageEditor} from "../common/utils.js";
import ThreeEditor from "./three-editor.js";
import ErpaViewer from "./erpa-viewer.js";
export default function Editor(props) {
  const {
    page,
    article,
    outsidePrintPath,
    insidePrintPath,
    config,
    readOnly,
    ...rest
  } = props;
  const productSlug = page.slug;
  const editor = getPageEditor(page);
  if (!editor)
    return null;
  if (editor.component === "editor_erpa") {
    if (!config)
      return null;
    if (readOnly) {
      return /* @__PURE__ */ React.createElement(ErpaViewer, {
        editorConfig: config,
        article,
        productSlug,
        outsideTexturePath: outsidePrintPath,
        insideTexturePath: insidePrintPath,
        product_page: page,
        ...editor,
        ...rest
      });
    }
    return /* @__PURE__ */ React.createElement(ErpaEditor, {
      editorConfig: config,
      article,
      productSlug,
      outsideTexturePath: outsidePrintPath,
      insideTexturePath: insidePrintPath,
      ...editor,
      ...rest
    });
  }
  if (editor.component === "editor_3d") {
    if (!config)
      return null;
    return /* @__PURE__ */ React.createElement(ThreeEditor, {
      outsideTexturePath: outsidePrintPath,
      insideTexturePath: insidePrintPath,
      editorConfig: config,
      article,
      productSlug,
      readOnly,
      ...editor,
      ...rest
    });
  }
  return /* @__PURE__ */ React.createElement(SimpleEditor, {
    outsideTexturePath: outsidePrintPath,
    productSlug,
    readOnly,
    ...editor,
    ...rest
  });
}
